import { NgModule } from "@angular/core";
import { DiscussionFeedComponent } from "./discussion-feed.component";
import { DiscussionFeedRoutingModule } from "./discussion-feed-routing.module";
import { SharedModule } from "../../../shared/shared.module";
import { DiscussionFeedNavTabsComponent } from "./discussion-feed-nav-tabs/discussion-feed-nav-tabs.component";
import { DiscussionFeedTagsComponent } from "./discussion-feed-tags/discussion-feed-tags.component";
import { DiscussionFeedAuthResolver } from "./discussion-feed-auth-resolver.service";

@NgModule({
  imports: [DiscussionFeedRoutingModule, SharedModule],
  declarations: [
    DiscussionFeedComponent,
    DiscussionFeedNavTabsComponent,
    DiscussionFeedTagsComponent,
  ],
  providers: [DiscussionFeedAuthResolver],
})
export class DiscussionFeedModule {}
